import React, { Component } from 'react';
import { FaBars } from 'react-icons/fa';
import '../styles/NavBar.css'

export default class NavBar extends Component {
    state = {
        scrolled: false,
        mobileMenu: false,
        texts: {
            HOME: {
                en: "Home",
                fr: "Accueil",
                ru: "В начало",
            },
            CHATEAX: {
                en: "Château",
                fr: "Le Château",
                ru: "Шато",
            },
            WINE: {
                en: "Wine",
                fr: "Vin",
                ru: "Вино",
            },
            SHOP: {
                en: "Shop",
                fr: "Boutique",
                ru: "Магазин",
            },
            GALLERY: {
                en: "Gallery",
                fr: "La Galerie",
                ru: "Галерея",
            },
            VISIT: {
                en: "Accommodation",
                fr: "Hébergement",
                ru: "Размещение",
            },
            CONTACTS: {
                en: "Contacts",
                fr: "Contacts",
                ru: "Контакты",
            },
            allrooms: {
                en: "all-rooms",
                fr: "toutes-les-proprietes"
            }
        },
    }

    componentDidMount =()=> {
        window.onscroll = () => {
            this.setState({
                scrolled: window.scrollY > 100 ? true : false
            })
        }
    }

    mobileMenuExpandClick =()=> {
        this.setState({mobileNav: !this.state.mobileMenu})
    }

    navClick =()=> {
        this.setState({mobileNav: false})
    }

    render() {
        const texts = this.state.texts;
        const lang = this.props.lang;
        const nav = this.props.nav;
        return (
            <header id="header" className={`fixed-top ${this.state.scrolled && 'header-scrolled'}`}>
                <div className="container d-flex align-items-center justify-content-between">

                    <h1 className="logo">
                        <img src="/logo.png" alt="" className="img-fluid"/>
                    </h1>

                    <nav id="navbar" className={`navbar ${this.state.mobileNav && 'navbar-mobile'}`}>
                        <ul className='spy'>
                            <li className={nav === 'home' && 'active'}><a href="/#home" onClick={this.navClick}>{texts.HOME[lang]}</a></li>
                            <li className={nav === 'chateau' && 'active'}><a href="#chateau" onClick={this.navClick}>{texts.CHATEAX[lang]}</a></li>
                            <li className={nav === 'wine' && 'active'}><a href="#wine" onClick={this.navClick}>{texts.WINE[lang]}</a></li>
                            <li className={nav === 'shop' && 'active'}><a href={`https://wine.lacroixdemillorit.com/${lang === 'fr' ? lang : ''}`} >{texts.SHOP[lang]}</a></li>
                            <li className={nav === 'visit' && 'active'}><a href={`https://www.bookings.lacroixdemillorit.com/${lang}/${texts.allrooms[lang]}`} onClick={this.navClick}>{texts.VISIT[lang]}</a></li>
                            <li className={nav === 'gallery' && 'active'}><a href="#gallery" onClick={this.navClick}>{texts.GALLERY[lang]}</a></li>
                            <li className={nav === 'contacts' && 'active'}><a href="#contacts" onClick={this.navClick}>{texts.CONTACTS[lang]}</a></li>
                        </ul>
                        <FaBars 
                            className={`bi bi-list mobile-nav-toggle ${this.state.scrolled && 'visible'}`}
                            onClick={this.mobileMenuExpandClick}
                        />
                    </nav>

                </div>
            </header>
  );
  }
}
